export enum VoiceCollectStep {
  form = "form",
  collectVoice = "collectVoice",
  result = "result",
  fail = "fail",
  permissionDenied = "permissionDenied",
}
